export const options = {
  jwtGet: null, // Function to get JSON Web Token
  ttsEndpoint: null,
  ttsApikey: null,
  ttsTrimStart: 0,
  ttsTrimEnd: 400,
  ttsLang: 'fi-FI',
  ttsVoice: 'fi-FI-Standard-A',
  ttsRate: 0.95,
  ttsPitch: 0,
  ttsVolume: 0,
  lipsyncLang: 'fi',
  pcmSampleRate: 22050,
  modelRoot: 'Armature',
  modelPixelRatio: 1,
  modelFPS: 30,
  cameraView: 'full',
  cameraDistance: 0,
  cameraX: 0,
  cameraY: 0,
  cameraRotateX: 0,
  cameraRotateY: 0,
  cameraRotateEnable: true,
  cameraPanEnable: false,
  cameraZoomEnable: false,
  lightAmbientColor: 0xffffff,
  lightAmbientIntensity: 2,
  lightDirectColor: 0x8888aa,
  lightDirectIntensity: 30,
  lightDirectPhi: 1,
  lightDirectTheta: 2,
  lightSpotIntensity: 0,
  lightSpotColor: 0x3388ff,
  lightSpotPhi: 0.1,
  lightSpotTheta: 4,
  lightSpotDispersion: 1,
  avatarMood: 'neutral',
  avatarMute: false,
  markedOptions: { mangle: false, headerIds: false, breaks: true },
  statsNode: null,
  statsStyle: null,
} as const;

export const VisemeNames = [
  'aa',
  'E',
  'I',
  'O',
  'U',
  'PP',
  'SS',
  'TH',
  'DD',
  'FF',
  'kk',
  'nn',
  'RR',
  'CH',
  'sil',
] as const;

export const VisemeDurations = {
  aa: 0.95,
  E: 0.9,
  I: 0.92,
  O: 0.96,
  U: 0.95,
  PP: 1.08,
  SS: 1.23,
  TH: 1,
  DD: 1.05,
  FF: 1.0,
  kk: 1.21,
  nn: 0.88,
  RR: 0.88,
  sil: 1,
} as const;
